import styled, { keyframes } from "styled-components";

export const SnippetContainer = styled.div`
	border-radius: 1rem;
	width: 800pxs;
`;
